export function getBackendHost({
  configuredHost = process.env.REACT_APP_BACKEND_HOST || '',
} = {}) {
  return configuredHost.replace(/\/$/, '');
}
